<template>
    <h1 class="dashboard-title">Настройки</h1>
    <div class="tab horizontal default-color">
        <router-link to="/dashboard/settings/verification" class="tab-button">Верификация</router-link>
        <router-link to="/dashboard/settings" class="tab-button">Персональные данные</router-link>
        <router-link to="/dashboard/settings/password" class="tab-button">Изменить пароль</router-link>
        <router-link to="/dashboard/settings/security" class="tab-button">Безопасноть</router-link>
    </div>
    <router-view></router-view>
</template>